
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ProductGroupFilter extends Vue {
  @Prop({ type: String, default: 'order' })
  type!: 'order' | 'claim';

  active = false;

  get groupLabels(): string[] {
    const groups =
      this.type === 'order'
        ? this.$store.getters['order/productGroups']()
        : this.$store.getters['claim/agreementProductGroups']();
    return Object.keys(groups);
  }

  toggle(active: boolean) {
    this.active = active;
  }

  groupActive(group: string): boolean {
    return this.type === 'order'
      ? this.$store.getters['order/isFilterGroup'](group)
      : this.$store.getters['claim/isFilterGroup'](group);
  }

  toggleGroupActive(group: string) {
    const user = this.$store.state.auth.user.username;
    this.$store.commit(`${this.type}/toggleFilterGroup`, { group, user });
  }

  onClickOutside() {
    this.active = false;
  }
}
